import { RadioGroup } from "radix-ui"

import { Text } from "../Text"
import styles from "./RadioButton.module.css"
import { RadioItem } from "./RadioItem"

export type RadioButtonProps = {
  label?: string
  disabled?: boolean
} & DecorativeRadioButtonProps

type DecorativeRadioButtonProps =
  | {
      /**
       * Whether this RadioButton is only included for decoration purposes
       * or is the actual Radio Group Item.
       */
      decorative: true
      value?: never
    }
  | {
      decorative?: false
      value: string
    }

export function RadioButton(props: RadioButtonProps) {
  const { value, label, disabled = false, decorative } = props

  const button = (
    <div className={styles.root}>
      <div className={styles.circle}>
        <RadioGroup.Indicator className={styles.indicator} />
      </div>
      {label && <Text>{label}</Text>}
    </div>
  )

  if (decorative) {
    return button
  }

  return (
    <RadioItem value={value} disabled={disabled}>
      {button}
    </RadioItem>
  )
}
